<template>
  <v-row no-gutters class="flex-nowrap">
    <v-col cols="12">
      <template v-if="isFetched">
        <v-row no-gutters :justify="$attrs.headerJustify || 'space-between'" style="gap: 0.5rem">
          <v-col cols="auto" class="text-left" v-if="hasTitleSlot" align-self="center">
            <slot name="title"></slot>
          </v-col>
          <v-col v-if="hasButtonSlot" cols="auto">
            <slot name="button"> </slot>
          </v-col>
          <v-col cols="4">
            <slot name="search"> </slot>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <slot name="list"> </slot>
          </v-col>
        </v-row>
        <slot name="dialogs"> </slot>
      </template>
      <template v-else>
        <main-loader> </main-loader>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import MainLoader from '@/components/MainLoader';

export default {
  name: 'AdminListWrapper',
  components: {
    MainLoader,
  },
  props: {
    isFetched: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasButtonSlot() {
      return !!Object.keys(this.$slots).find(slot => slot.split('.')[0] === 'button');
    },
    hasTitleSlot() {
      return !!Object.keys(this.$slots).find(slot => slot.split('.')[0] === 'title');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-input__icon .v-icon {
    font-size: 18px;
  }
  .v-text-field__slot input {
    font-size: 12px;
  }
}
</style>
